import { useCallback } from 'react';

import Email from '../../models/Engines/Email';
import EnginesService from '../../services/EnginesService';
import ErrorResponse from '../../types/ErrorResponse';
import ItemResponse from '../../types/ItemResponse';
import useItemQuery from '../useItemQuery';

const useEnginesIpListQuery = () => {
	const fetcher = useCallback(
		async (
			dataSetter: (data: ItemResponse<Email>) => void,
			errorSetter: (error: ErrorResponse) => void,
			domain: string,
		) => {
			await new EnginesService().email(domain, dataSetter, errorSetter);
		},
		[],
	);

	return useItemQuery(fetcher);
};

export default useEnginesIpListQuery;
